import React from 'react';
import orcatec from '@/public/images/partners/orcatec.png';
import bryant from '@/public/images/partners/bryant.png';
import Image from 'next/image';
import Link from 'next/link';

const items = [
  {
    href: 'https://orcatec.com/',
    image: orcatec,
    description:
      'Empower your business with the most reliable home service software solution. Our all-in-one platform, used by professionals in over 40 service industries, can be your go-to tool for effective home service management. Schedule services, dispatch teams, handle invoicing, and track performance seamlessly - with Orcatec, success is just a click away. If you are looking for a Free Home Services Software, Orcatec is what you need.',
  },
  {
    href: 'https://www.bryant.com/en/us/',
    image: bryant,
    description: `Tytum is proud to be an official Bryant partner and dealer, giving us exclusive access to their certified heating and cooling products. This partnership allows us to provide our customers with top-quality, reliable solutions that ensure comfort and efficiency in every home and business. Trust Tytum to deliver the best in Bryant's advanced technology, backed by expert installation and service.`,
  },
];

export const Partners = () => {
  return (
    <ul>
      {items.map((item, idx) => (
        <li
          key={idx}
          className="mb-20 flex flex-wrap items-center justify-between md:flex-nowrap "
        >
          <div className="flex w-full items-center justify-center">
            <Link href={item.href}>
              <Image src={item.image} alt={item.description} />
            </Link>
          </div>
          <p className="w-full">{item.description}</p>
        </li>
      ))}
    </ul>
  );
};
